module.exports = __webpack_public_path__ + "static/media/1200w.22f9b7e6.jpg";